export const USCurrencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
});

export const formatCurrency = (amount: number) => {
  return USCurrencyFormatter.format(amount);
};
